import { gql } from '@apollo/client'

export const GET_MEAL_DETAILS_FROM_TRIP = gql`
    query getMealDetailsFromTripByTripId($page: PageInput!, $tripId: NonEmptyString!) {
        getMealDetailsFromTripByTripId(page: $page, trip_id: $tripId) {
            code
            success
            message
            trip_meals {
                trip_meal_id
                trip_id
                meal_detail {
                    meal_id
                    description {
                        en
                        ar
                    }
                    price {
                        base
                        tax
                    }
                    active
                }
            }
        }
    }
`

export const SEARCH_MEAL = gql`
    query searchMeal($page: PageInput!, $statusCode: Boolean, $name: String, $searchMealId: String) {
        searchMeal(page: $page, status_code: $statusCode, name: $name, id: $searchMealId) {
            code
            success
            message
            meals {
                meal_id
                description {
                    en
                    ar
                }
                price {
                    base
                    tax
                }
                active
            }
        }
    }
`

export const SEARCH_MEAL_SUMMARY = gql`
    query SearchMealSummary($tripId: String, $toDate: LocalDate!, $fromDate: LocalDate!, $mealId: String) {
        searchMealSummary(trip_id: $tripId, toDate: $toDate, fromDate: $fromDate, meal_id: $mealId) {
            code
            success
            message
            trip_meals_summary {
                meal_id
                meal_name_en
                meal_name_ar
                meal_count
            }
        }
    }
`

export const MEAL_STATUS = gql`
    query MealStatus($code: String) {
        mealStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
